export const dataAllMX = {
  Ventajas: [
    "Pagos incluidos al mes",
    "Comisión por pago exitoso adicional",
    "Personaliza con tu logo y colores",
    "Quick Transfer",
    "Payment Links",
    "Conciliación automática",
    "Evolución de los pagos y analítica",
    "Multiples comercios",
    "",
    "Administración",
    "Usuarios de gestión",
    "Administración de roles de seguridad",
    "",
    "Soporte",
    "Atención en horario de oficina",
    "Correo electrónico",
    "Chat en línea",
    "Atención prioritaria 24/7",
    "Reporte de incidencias",
    "Gestor de cuenta dedicado (KAM)",
  ],
  Starter: [
    "Paga por uso",
    "",
    "Si",
    "Si",
    "",
    "",
    "",
    "",
    "",
    "",
    "1",
    "",
    "",
    "",
    "Si",
    "Si",
  ],
  "": [],
  Lite: [
    "150",
    "1.2%",
    "Si",
    "Si",
    "Si",
    "Si",
    "",
    "",
    "",
    "",
    "2",
    "",
    "",
    "",
    "Si",
    "Si",
    "Si",
  ],
  " ": [],
  Plus: [
    "400",
    "1%",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
    "",
    "",
    "",
    "5",
    "Si",
    "",
    "",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
  ],
  "  ": [],
  Enterprise: [
    "A la medida",
    "A la medida",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
    "",
    "",
    "Ilimitados",
    "Si",
    "",
    "",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
  ],
};
export const dataBeginnerMX = {
  Ventajas: [
    "Pagos incluidos al mes",
    "Comisión por pago exitoso adicional",
    "Quick Transfer",
    "Payment Links",
    "Conciliación automática",
    "Multiples comercios",
    "Personaliza con tu logo y colores",
    "",
    "Administración",
    "Usuarios de gestión",
    "Administración de roles de seguridad",
    "",
    "Soporte",
    "Atención en horario de oficina",
    "Correo electrónico",
    "Chat en línea",
    "Atención prioritaria 24/7",
    "Reporte de incidencias",
    "Gestor de cuenta dedicado (KAM)",
  ],
  Starter: [
    "Paga por uso",
    "1.5%",
    "Si",
    "Si",
    "",
    "",
    "",
    "",
    "1",
    "",
    "",
    "",
    "Si",
  ],
  "": [],
  Lite: [
    "150",
    "1.2%",
    "Si",
    "Si",
    "Si",
    "",
    "Si",
    "",
    "",
    "2",
    "",
    "",
    "",
    "Si",
  ],
};
export const dataPremiumMX = {
  Ventajas: [
    "Pagos incluidos al mes",
    "Comisión por pago exitoso adicional",
    "Quick Transfer",
    "Payment Links",
    "Conciliación automática",
    "Multiples comercios",
    "Personaliza con tu logo y colores",
    "",
    "Administración",
    "Usuarios de gestión",
    "Administración de roles de seguridad",
    "",
    "Soporte",
    "Atención en horario de oficina",
    "Correo electrónico",
    "Chat en línea",
    "Atención prioritaria 24/7",
    "Reporte de incidencias",
    "Gestor de cuenta dedicado (KAM)",
  ],
  Plus: [
    "400",
    "0.9%",
    "Si",
    "Si",
    "Si",
    "",
    "Si",
    "",
    "",
    "5",
    "Si",
    "",
    "",
    "Si",
  ],

  "  ": [],
  Enterprise: [
    "A la medida",
    "A la medida",
    "Si",
    "Si",
    "Si",
    "Si",
    "Si",
    "",
    "",
    "Ilimitados",
    "Si",
    "",
    "",
    "Si",
    "Si",
    "Si",
  ],
};

export const dataAllMX2 = [
  {
    title: "Pagos incluidos al mes",
    basic: "Paga por uso",
    starter: "150",
    plus: "400",
    enterprise: "A la medida",
  },
  {
    title: "Monto máximo procesado al mes",
    titleSupIni: "2",
    basic: "Sin límite",
    starter: "$150,000 MXN",
    plus: "$500,000 MXN",
    enterprise: "Sin límite",
  },
  {
    title: "Comisión por operación fuera del plan",
    text: "Cuando superes la cantidad de pagos o el monto máximo procesado incluidos en tu plan mensual no interrumpiremos tu servicio. En su lugar, te cobraremos la comisión establecida.",

    starter: "1.6%",
    plus: "1.5%",
    enterprise: "A la medida",
  },
  {
    title: "Personaliza con tu logo y colores",
    basicCheck: true,
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Quick Transfer",
    basicCheck: true,
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Payouts",
    basicCheck: true,
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Conciliación automática",
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Evolución de los pagos y analítica",
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Múltiples comercios",
    tooltip:
      "Gestiona y unifica todas las transacciones en un solo lugar. Para empresas con más de una tienda o negocio.",
  },
  { fullTitle: "Administración" },
  {
    title: "Usuarios de gestión",
    basic: "1",
    starter: "2",
    plus: "5",
    enterprise: "Ilimitados",
  },
  {
    title: "Administración de roles de seguridad",
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    fullTitle: "Soporte",
  },
  {
    title: "Atención en horario de oficina",
    tooltip: "De Lunes a Viernes de 9:00 a 18:00 Hrs",
    basicCheck: true,
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Correo electrónico",
    basicCheck: true,
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Chat en línea",
    starterCheck: true,
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Atención prioritaria 24/7",
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Reporte de incidencias",
    plusCheck: true,
    enterpriseCheck: true,
  },
  {
    title: "Gestor de cuenta dedicado (KAM)",
    enterpriseCheck: true,
  },
];
